<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="orderTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="state" slot-scope="data">
          <span style="color: #409eff;" v-if="data.row.state*1 === 1">未兑换</span>
          <span style="color: #f56c6c;" v-if="data.row.state*1 === 2">已兑换未评价</span>
          <span style="color: #67c23a;" v-if="data.row.state*1 === 3">已评价</span>
          <span style="color: #909399;" v-if="data.row.state*1 === 4">已取消</span>
        </template>
        <template slot="orderType" slot-scope="data">
          <span>{{data.row.orderType | FILTER_Order_type}}</span>
        </template>
        <template slot="wtFormTableListButtonsAfter" slot-scope="scope">
         <template v-if="scope.row.orderType*1 === 1  && scope.row.state*1 === 1">
          <wt-auth class="search-form-btn">
            <el-button size="mini" type="primary" @click="toClickAction(scope.row)">兑换</el-button>
          </wt-auth>
         </template>
        </template>
        <template slot="orderGoodsList" slot-scope="data">
          <span>{{ transGoodsName(data.row.orderGoodsList) }}</span>
        </template>
       </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_ORDER',
        formComponent: {
          view: { type: 'component', componentName: 'Order-view', value: 'queryOrderDetailData', noRequest: true },
          add: { type: 'component', componentName: 'Order-edit', value: 'resetOrderDetailData' },
          edit: { type: 'component', componentName: 'Order-edit', value: 'queryOrderDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/order/orderList' },
          delete: { type: 'default', value: '/modules/order/orderDelete' }
        },
        formInputsData: [{ name: '订单编号', key: 'orderNumber', value: '', type: 'text' },
          { name: '订单状态',
            key: 'state',
            value: '',
            type: 'select',
            data: [
              { label: '全部', value: '' },
              { label: '未兑换', value: 1 },
              { label: '已兑换未评价', value: 2 },
              { label: '已评价', value: 3 },
              { label: '已取消', value: 4 }
            ] },
          { name: '下单时间', key: 'updateTimeRange', value: [], type: 'datetime' },
          { name: '用户昵称', key: 'nickName', value: '', type: 'text' },
          { name: '兑换方式',
            key: 'orderType',
            value: '',
            type: 'select',
            data: [{ label: '全部', value: '' },
              { label: '自提', value: 1 },
              { label: '售货柜', value: 2 },
              { label: '代换', value: 3 }] },
          { name: '售货柜订单', key: 'onlineOrderId', value: '', type: 'text' },
          { name: '售货柜', key: 'onlineMachine', value: '', type: 'text' },
          // { name: '站点名称', key: 'siteName', value: '', type: 'text' },
          { name: '站点', key: 'siteIdList', value: [], type: 'cascader', options: [], props: { children: 'childList', label: 'name', value: 'id', expandTrigger: 'hover', emitPath: false, multiple: true }},
          { name: '商品名称', key: 'goodsName', value: '', type: 'text' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXCEL',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/order/orderListImport',
          fileName: '订单',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '订单编号', key: 'orderNumber', type: 'text' },
          { name: '售货柜订单', key: 'onlineOrderId', type: 'text' },
          { name: '商品名称', key: 'orderGoodsList', type: 'custom' },
          { name: '站点名称', key: 'siteName', type: 'text' },
          { name: '兑换积分', key: 'totalIntegral', type: 'text' },
          { name: '兑换方式', key: 'orderType', type: 'custom' },
          { name: '售货柜', key: 'onlineMachine', type: 'text' },
          { name: '用户昵称', key: 'nickName', type: 'text' },
          { name: '手机号码', key: 'phone', type: 'text' },
          { name: '下单时间', key: 'createTime', sortable: 'custom', type: 'text' },
          { name: '兑换时间', key: 'exchangeTime', type: 'text', sortable: 'custom' },
          { name: '订单状态', key: 'state', type: 'custom' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true }
      }
    }
  },
  mounted() {
    this.orgTreeList()
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'VIEW') {
          this.$store.dispatch('setOrderDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    },
    toClickAction(row) {
      this.$wtUtil.deleteConfirm(this, `确认兑换吗？`).then(() => {
        request({
          url: '/modules/order/orderStateEdit',
          method: 'post',
          data: {
            id: row.id
          }
        }).then(res => {
          if (!res) return false
          this.$refs.orderTableRef.requestList()
          this.$message({ message: '操作成功', type: 'success' })
        })
      })
    },
    transGoodsName(data) {
      const names = []
      for (const item of data) {
        names.push(item.goodsTitle)
      }
      return names.join('、')
    },
    // 站点
    orgTreeList() {
      this.$api.siteManage.org.orgTreeList().then(res => {
        this.$wtUtil.setSiteLevelKey(res.data)
        this.form.formInputsData[this.form.formInputsData.length - 2].options = res.data
      })
    }
  }
}
</script>
